import axios from "axios";

const CustomAPICalls = async(mydata, path, method = "post") => {
    try{
        const data = JSON.stringify({
            ...mydata,
        })
    
        const url = process.env.REACT_APP_API_BASE_URL + path;
    
        const config = {
            method: method,
            url: url,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
        };
    
        const response = await axios.request(config);
        // console.log("before" , response);
    
        if(response.status === 200){
            return response;
        }
        return false;

    }catch(error){
        throw error; // Re-throw the error to ensure it is not swallowed
    }

}

export default CustomAPICalls;
